import CompanyProfile from './CompanyProfile'
export default CompanyProfile